import React from "react";

/* eslint-disable max-len */
export default function CheckboxIcon() {
	return (
		<svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 30.62 30.56" enableBackground="new 0 0 30.62 30.56" xmlSpace="preserve">
			<path fill="none" stroke="#757575" strokeWidth="3" strokeMiterlimit="10" d="M25.92,28.89H4.67c-1.66,0-3-1.34-3-3V4.63
	c0-1.66,1.34-3,3-3h21.25c1.66,0,3,1.34,3,3v21.25C28.92,27.54,27.58,28.89,25.92,28.89z"/>
		</svg>
	);
}
